/**
 * Star Wars Collection — Interactive Features
 * Custom cursors (lightsaber + kyber crystal) and countdown timer.
 * Cursors only appear over Star Wars sections, not header/footer.
 */

(function () {
  'use strict';

  /* ===== DEBUG — remove after confirming cursor works ===== */
  console.log('[SW] c-star-wars.js loaded');

  /* ===== TOUCH DETECTION ===== */
  /* Use coarse pointer detection — more reliable than hover:none
     on MacBooks with trackpads which can falsely report hover:none */
  var isTouchOnly = (
    'ontouchstart' in window &&
    window.matchMedia('(pointer: coarse)').matches &&
    !window.matchMedia('(pointer: fine)').matches
  );

  console.log('[SW] Touch-only device:', isTouchOnly);

  /* ===== CUSTOM CURSOR ===== */
  if (!isTouchOnly) {
    var themeEl = document.querySelector('[data-sw-theme]');
    console.log('[SW] Theme element found:', themeEl);

    if (themeEl) {
      var theme = themeEl.getAttribute('data-sw-theme');
      console.log('[SW] Theme:', theme);

      if (theme === 'light' || theme === 'dark') {
        initSaberCursor(theme);
        console.log('[SW] Saber cursor initialized (' + theme + ')');
      } else if (theme === 'retro') {
        initKyberCursor();
        console.log('[SW] Kyber cursor initialized');
      }
    } else {
      console.log('[SW] ERROR: No [data-sw-theme] element found in DOM');
    }
  } else {
    console.log('[SW] Skipping cursor — touch-only device');
  }

  /* SW section selectors — cursor only shows over these */
  var SW_SECTIONS = '.c-sw-hero, .sw-grid-section, .c-sw-countdown, .marquee-container, .video-holder[data-sw-theme]';

  function isOverSwSection(el) {
    if (!el) return false;
    return !!el.closest(SW_SECTIONS);
  }

  function initSaberCursor(theme) {
    var saber = document.createElement('div');
    saber.className = 'sw-saber-cursor sw-saber-cursor--' + theme;
    /* \u200B (zero-width space) prevents theme div:empty rule from hiding these */
    saber.innerHTML =
      '<div class="sw-saber-cursor__inner">' +
        '<div class="sw-saber-cursor__blade">\u200B</div>' +
        '<div class="sw-saber-cursor__hilt">\u200B</div>' +
      '</div>';
    document.body.appendChild(saber);

    var trailClass = 'sw-saber-trail sw-saber-trail--' + theme;

    document.addEventListener('mousemove', function (e) {
      var target = document.elementFromPoint(e.clientX, e.clientY);

      if (isOverSwSection(target)) {
        saber.style.display = 'block';
        saber.style.left = e.clientX + 'px';
        saber.style.top = e.clientY + 'px';

        /* Spawn trail particle */
        var trail = document.createElement('div');
        trail.className = trailClass;
        trail.textContent = '\u200B';
        trail.style.left = e.clientX + 'px';
        trail.style.top = (e.clientY + 14) + 'px';
        document.body.appendChild(trail);

        setTimeout(function () {
          trail.style.opacity = '0';
          trail.style.transition = 'opacity 0.4s';
          setTimeout(function () { trail.remove(); }, 400);
        }, 100);
      } else {
        saber.style.display = 'none';
      }
    });

    document.addEventListener('mouseleave', function () {
      saber.style.display = 'none';
    });
  }

  function initKyberCursor() {
    var kyber = document.createElement('div');
    kyber.className = 'sw-kyber-cursor';
    kyber.innerHTML =
      '<div class="sw-kyber-cursor__wrapper">' +
        '<div class="sw-kyber-cursor__glow">\u200B</div>' +
        '<div class="sw-kyber-cursor__edge">\u200B</div>' +
        '<div class="sw-kyber-cursor__shape">\u200B</div>' +
      '</div>';
    document.body.appendChild(kyber);

    document.addEventListener('mousemove', function (e) {
      var target = document.elementFromPoint(e.clientX, e.clientY);

      if (isOverSwSection(target)) {
        kyber.style.display = 'block';
        kyber.style.left = e.clientX + 'px';
        kyber.style.top = e.clientY + 'px';

        var isInteractive = target && (
          target.closest('a') ||
          target.closest('button') ||
          target.closest('.sw-card') ||
          target.closest('input') ||
          target.closest('select')
        );
        kyber.classList.toggle('is-hovering', !!isInteractive);
      } else {
        kyber.style.display = 'none';
      }
    });

    document.addEventListener('mouseleave', function () {
      kyber.style.display = 'none';
    });
  }

  /* ===== COUNTDOWN TIMER ===== */
  var countdownEls = document.querySelectorAll('[data-sw-countdown]');
  countdownEls.forEach(function (el) {
    var targetDate = new Date(el.getAttribute('data-sw-countdown')).getTime();
    var timerEl = el.querySelector('.c-sw-countdown__timer');
    var expiredEl = el.querySelector('.c-sw-countdown__expired');

    if (!timerEl) return;

    var daysEl = el.querySelector('[data-sw-days]');
    var hoursEl = el.querySelector('[data-sw-hours]');
    var minutesEl = el.querySelector('[data-sw-minutes]');
    var secondsEl = el.querySelector('[data-sw-seconds]');

    function update() {
      var now = Date.now();
      var diff = targetDate - now;

      if (diff <= 0) {
        timerEl.style.display = 'none';
        if (expiredEl) expiredEl.style.display = 'block';
        clearInterval(interval);
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    var interval = setInterval(update, 1000);
  });
})();
